/* Bag "Add a little extra": personal picks (snippets/upsell-block.liquid ranks them).
 *
 * The cards stay server-rendered (same markup, same quick add, no layout shift), so the
 * shopper's on-device signals are handed to Liquid as ONE hidden cart attribute:
 *
 *   _rl_recs = "<wishlist handles>|<recently viewed handles>|<Shopify related handles>"
 *
 * Product handles only, written to this store's own cart (the same channel runit-flags.js
 * uses). Nothing about the shopper is sent anywhere. Liquid adds the same-design siblings
 * from the bag itself and does every eligibility check (stock, drops, Club, hidden).
 *
 * Recently viewed: the last 12 product pages, on this device (runit:viewed:v1).
 * Related: Shopify's /recommendations/products.json (complementary, then related) for the
 * product being viewed and the bag lines, fetched once per product per session.
 * When the value changes the drawer HTML is refreshed while it is closed, so an open
 * drawer never reshuffles under the shopper's thumb.
 */
(function () {
  'use strict';

  var VIEWED_KEY = 'runit:viewed:v1';
  var RECS_KEY = 'runit:recs:v1';
  var ATTR = '_rl_recs';
  var PER_LIST = 6;
  var HANDLE = /^[a-z0-9][a-z0-9-]{0,254}$/;

  function clean(list, exclude, limit) {
    var out = [];
    for (var i = 0; i < (list || []).length && out.length < limit; i++) {
      var h = String(list[i] || '').toLowerCase();
      if (HANDLE.test(h) && out.indexOf(h) === -1 && (exclude || []).indexOf(h) === -1) out.push(h);
    }
    return out;
  }

  /* Pure: the attribute value for these signals. Bag handles never take a slot. */
  function build(wishlist, viewed, related, bag) {
    var w = clean(wishlist, bag, PER_LIST);
    var v = clean(viewed, bag.concat(w), PER_LIST);
    var r = clean(related, bag.concat(w, v), PER_LIST);
    return w.length || v.length || r.length ? [w.join(','), v.join(','), r.join(',')].join('|') : '';
  }

  /* Pure: most recent first, unique, capped. */
  function pushViewed(list, handle) {
    return clean([handle].concat(list || []), [], 12);
  }

  var api = { build: build, pushViewed: pushViewed };
  if (typeof window !== 'undefined') window.rlBagRecs = api;
  if (typeof document === 'undefined' || !window.fetch || window.__rlBagRecsBound) return;
  window.__rlBagRecsBound = true;

  function read(store, key, fallback) {
    try { var v = JSON.parse(store.getItem(key)); return v == null ? fallback : v; } catch (e) { return fallback; }
  }
  function write(store, key, value) {
    try { store.setItem(key, JSON.stringify(value)); } catch (e) {}
  }
  var local, session;
  try { local = window.localStorage; session = window.sessionStorage; } catch (e) { return; }
  if (!local || !session) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var pdp = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
  var pdpId = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product &&
    window.ShopifyAnalytics.meta.product.id;
  if (pdp) write(local, VIEWED_KEY, pushViewed(read(local, VIEWED_KEY, []), decodeURIComponent(pdp)));

  /* Same storage the wishlist itself uses (guest key, or this customer's account cache). */
  function wishlistHandles() {
    var core = window.RunItWishlistCore;
    var cfg = document.querySelector('[data-runit-wishlist-root]');
    var id = cfg && cfg.getAttribute('data-customer-id');
    var key = core ? (id ? core.cacheKey(id) : core.KEY) : 'runit:wishlist:v1';
    var items = read(local, key, []);
    if (!Array.isArray(items)) return [];
    return items
      .filter(function (i) { return i && i.handle && i.available !== false; })
      .sort(function (a, b) { return (Number(b.addedAt) || 0) - (Number(a.addedAt) || 0); })
      .map(function (i) { return i.handle; });
  }

  function recsFor(id) {
    var cache = read(session, RECS_KEY, {});
    if (cache[id]) return Promise.resolve(cache[id]);
    function get(intent) {
      return fetch(root + 'recommendations/products.json?product_id=' + id + '&limit=6&intent=' + intent)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) {
          return (j.products || []).filter(function (p) { return p.available; }).map(function (p) { return p.handle; });
        })
        .catch(function () { return []; });
    }
    return Promise.all([get('complementary'), get('related')]).then(function (lists) {
      var handles = clean(lists[0].concat(lists[1]), [], 12);
      var fresh = read(session, RECS_KEY, {});
      fresh[id] = handles;
      write(session, RECS_KEY, fresh);
      return handles;
    });
  }

  var dirty = false;
  function drawerEl() { return document.querySelector('cart-drawer'); }
  function drawerOpen() { var d = drawerEl(); return !!(d && d.classList.contains('active')); }
  /* Same swap the theme (and runit-wishlist.js) does after every cart change. */
  function refreshDrawer() {
    if (drawerOpen()) { dirty = true; return; }
    dirty = false;
    fetch(root + '?sections=cart-drawer')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (s) {
        if (!s || !s['cart-drawer'] || drawerOpen()) { if (s) dirty = true; return; }
        var fresh = new DOMParser().parseFromString(s['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        var live = document.getElementById('CartDrawer');
        if (fresh && live) live.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  var running = null, again = false;
  function sync() {
    if (running) { again = true; return running; }
    running = fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        // Nothing to rank for: an empty bag shows no rail, unless this page's product may be added next.
        if (!cart.item_count && !pdpId) return;
        var bag = (cart.items || []).map(function (i) { return i.handle; });
        var ids = [];
        if (pdpId) ids.push(String(pdpId));
        (cart.items || []).forEach(function (i) { if (ids.indexOf(String(i.product_id)) === -1) ids.push(String(i.product_id)); });
        return Promise.all(ids.slice(0, 4).map(recsFor)).then(function (lists) {
          var value = build(wishlistHandles(), read(local, VIEWED_KEY, []), [].concat.apply([], lists), bag);
          if (value === ((cart.attributes && cart.attributes[ATTR]) || '')) return;
          var attributes = {};
          attributes[ATTR] = value;
          return fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: attributes })
          }).then(function (r) { if (r.ok && cart.item_count) refreshDrawer(); });
        });
      })
      .catch(function () { /* recommendations are best effort; the bag must never notice */ })
      .then(function () {
        running = null;
        if (again) { again = false; sync(); }
      });
    return running;
  }

  var timer;
  function soon() { clearTimeout(timer); timer = setTimeout(sync, 400); }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, soon);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-runit-wishlist-toggle]')) soon();
  });
  window.addEventListener('storage', function (e) { if (e.key && e.key.indexOf('runit:wishlist') === 0) soon(); });
  /* A refresh that had to wait for the drawer to close. */
  var d = drawerEl();
  if (d && window.MutationObserver) {
    new MutationObserver(function () { if (dirty && !drawerOpen()) setTimeout(refreshDrawer, 500); })
      .observe(d, { attributes: true, attributeFilter: ['class'] });
  }
  sync();
})();
